<script setup>
import { useRegisterSW } from 'virtual:pwa-register/vue';

const { needRefresh, updateServiceWorker } = useRegisterSW();
</script>

<template>
  <Transition
    enter-active-class="transition ease-out duration-300"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition ease-in duration-200"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <div
      v-if="needRefresh"
      class="fixed bottom-18 h-16 left-1/2 -translate-x-1/2 w-full  z-50 flex items-center justify-center gap-4 bg-[var(--bg-inverse)]  px-5 py-3 text-sm text-[var(--brand-on-primary)] shadow-lg"
    >
      <span>Hay una nueva versión disponible.</span>
      <button
        class="rounded bg-[var(--brand-primary)] px-3 py-2 text-xs font-medium text-[var(--brand-on-primary)] hover:bg-[var(--brand-primary-hover)]"
        @click="updateServiceWorker()"
      >
        Actualizar
      </button>
    </div>
  </Transition>
</template>
